import React from 'react';
import PropTypes from 'prop-types';

import Loading from '../../../../components/loading';

import moment from 'moment';
import zipObject from 'lodash/zipObject';
import lodash from 'lodash';

import UpdatePanel from './update-panel';
import ContinuePanel from '../../../../components/continue-panel';
import DialogPrompt from './dialog-prompt';
import getOrderUnknownCondition from './orderUnknown';

import {
  createGsheet,
  readGsheet,
  deleteGsheet,
  updateColumn,
  getColumnIndexName,
  updateSheet,
} from '../../../../components/gsheet';
import {hideColumn, showColumn, setColumnWidth} from '../../../../components/gsheet/format';

import {
  getDRMutations,
} from '../../../../utils/QA';

import {fetchDrugNames} from '../fetch-rx-history';

import downloadWorkbook from '../../../../components/workbook/download';
import updateData from './update-data';

// import {
//   protectFirstRow,
// } from '../../../../components/gsheet/format';


export default class GsheetTable extends React.Component {

  static propTypes = {
    rawDataCollection: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
  };

  constructor() {
    super(...arguments);
    this.state = {
      showValidateDialog: false,
      showSubmit: false,
      loadGSheet: false,
      disableButtons: false,
      sheet: "Rx"
    };
  }

  set processing(value) {
    if (value) {
      this.setState({
        loadGSheet: true,
        disableButtons: true,
      });
    } else {
      this.setState({
        loadGSheet: false,
        disableButtons: false,
      });
    }
  }

  async componentDidMount() {
    await this.handleCreateGsheet();

    // window.addEventListener('beforeunload',
    //   this.handleDeleteGsheet(this.props.rawDataCollection.spreadsheet_id)
    // );
  }

  get header() {
    return this._headers.map((item) => (item[0]));
  }

  get _headers() {
    const {rawDataCollection} = this.props;
    const {sequenceType} = rawDataCollection;

    let header =  [
      ['Patient Alias', 'ptAlias'],
      ['Weeks', 'weeks'],
      ['Start Date', 'startDate'],
      ['Stop Date', 'stopDate'],
      ['Drugs', 'drugs'],
      ['Duraton\nUnknown', 'durationUnknown'],
      ['Order\nunknown', 'orderUnknown'],
      ['Accession', 'accession'],
      ['Isolate Name', 'isolateName'],
      ['Isolate Date', 'isolateDate'],
    ];

    if (sequenceType === 'complete') {
      header.push(
        ['DRMs', 'drms']
      );
    } else {
      header.push(
        ['Mutations', 'mutations']
      );
    }

    return header;
  }

  get header2Property() {
    const mapper = {};
    for (const header of this._headers) {
      mapper[header[0]] = header[1];
    }
    return mapper;
  }

  get property2header() {
    const mapper = {};
    for (const header of this._headers) {
      mapper[header[1]] = header[0];
    }
    return mapper;
  }

  getPatientSequences(ptAlias, startDate, stopDate) {
    startDate = moment(startDate);
    stopDate = moment(stopDate);

    const {rawDataCollection} = this.props;
    const {rawSequences} = rawDataCollection;

    let sequences = rawSequences.filter((seq) => {
      return seq.ptAlias === ptAlias;
    });

    sequences = sequences.filter((seq) => {
      const isolateDate = moment(seq.isolateDate);
      return isolateDate > startDate && isolateDate <= stopDate;
    });

    return sequences;
  }

  getDRMMutations(alignments) {
    if (!alignments) {
      return '';
    }
    return alignments.geneSequences.map((gene) => {
      const geneName = gene.gene;
      const muts = getDRMutations(gene);
      const mutString = muts.map(
        ({shortText}) => {
          return shortText;
        }).join(',');
      return `${geneName}: ${mutString}`;
    }).join('\n');
  }

  get table() {
    const {rawDataCollection} = this.props;
    const {sequenceType} = rawDataCollection;

    if (sequenceType === 'incomplete') {
      return this.mutation_table;
    } else {
      return this.sequence_table;
    }

  }

  get mutation_table() {
    const {rawDataCollection} = this.props;

    const {rawSequenceMap} = rawDataCollection;

    const {rawRxHistory} = rawDataCollection;

    let table = [];

    for (const rxData of rawRxHistory) {
      const {ptAlias, existingPatientId} = rxData;
      const {startDate, stopDate} = rxData;
      const {rawSequenceUuid} = rxData;
      const rawSeq = rawSequenceMap[rawSequenceUuid] || {};

      let accessions = rawSeq.accession;
      let isolateNames = rawSeq.isolateName;
      let isolateDates = rawSeq.isolateDate;
      let mutations = rawSeq.mutations;
      if (existingPatientId || ptAlias) {
        const sequences = this.getPatientSequences(
          ptAlias, startDate, stopDate);
        accessions = sequences.map((seq) => (seq.accession)).join(', ');
        isolateNames = Array.from(new Set(
          sequences.map((seq) => (seq.isolateName)))).join(', ');
        isolateDates = Array.from(new Set(
          sequences.map((seq) => (seq.isolateDate)))).join(', ');
        mutations = sequences.map((seq) => {
          let muts = seq.mutations;
          if (!muts || muts === '') {
            muts = 'None';
          }
          return `${seq.gene}:${muts}`;
        }).join('\n');
      }

      let record = [
        rxData.ptAlias,
        rxData.weeks,
        rxData.startDate,
        rxData.stopDate,
        rxData.drugs,
        rxData.durationUnknown,
        // getOrderUnknownCondition(this.header, 'drugs'),
        rxData.orderUnknown,
        accessions,
        isolateNames,
        isolateDates,
        mutations,
      ];

      table.push(record);
    }
    table.unshift(this.header);
    return table;

  }

  get sequence_table() {

    const {rawDataCollection} = this.props;

    const {rawSequenceMap, rawAlignments} = rawDataCollection;

    const {rawRxHistory} = rawDataCollection;

    let rawAlignmentMap = {};
    if (rawAlignments && rawAlignments.length > 0) {
      rawAlignmentMap = rawAlignments.reduce(
        (acc, rawAlign) => {
          acc[rawAlign.rawSequenceUuid] = rawAlign;
          return acc;
        }, {}
      );
    }

    let table = [];

    for (const rxData of rawRxHistory) {
      const {ptAlias, existingPatientId} = rxData;
      let {
        startDate, stopDate, weeks,
        drugs, durationUnknown,
      } = rxData;
      const {rawSequenceUuid} = rxData;
      const rawSeq = rawSequenceMap[rawSequenceUuid] || {};
      const rawAlignment = rawAlignmentMap[rawSequenceUuid] || null;

      let accessions = rawSeq.accession;
      let isolateNames = rawSeq.isolateName;
      let isolateDates = rawSeq.isolateDate;
      let mutations = rawAlignment && this.getDRMMutations(rawAlignment);
      if (existingPatientId || ptAlias) {
        const sequences = this.getPatientSequences(
          ptAlias, startDate, stopDate);
        accessions = sequences.map((seq) => (seq.accession)).join(',\n');
        isolateNames = Array.from(new Set(
          sequences.map((seq) => (seq.isolateName)))).join(',\n');
        isolateDates = Array.from(new Set(
          sequences.map((seq) => (seq.isolateDate)))).join(',\n');
        const alignments = sequences.map(
          (seq) => (rawAlignmentMap[seq.uuid]));
        mutations = Array.from(new Set(alignments.map((aligment) => {
          return this.getDRMMutations(aligment);
        }))).join('\n');
      }

      if (!rawDataCollection.hasSimpleRawRxHistory) {
        drugs = 'Unknown';
      }

      let record = [
        rxData.ptAlias,
        weeks,
        startDate,
        stopDate,
        drugs,
        durationUnknown,
        getOrderUnknownCondition(this.header, 'drugs'),
        accessions,
        isolateNames,
        isolateDates,
        mutations,
      ];

      table.push(record);
    }
    table.unshift(this.header);
    return table;
  }

  get formats() {
    let result = [];

    // result.push(protectFirstRow());

    const {rawDataCollection} = this.props;

    const property2header = this.property2header;

    result.push(
      setColumnWidth(this.header, property2header['drugs'], 100)
    );

    if (rawDataCollection.hasSimpleRawRxHistory) {
      result = result.concat([
        hideColumn(this.header, property2header['startDate']),
        hideColumn(this.header, property2header['stopDate']),
        hideColumn(this.header, property2header['weeks']),
        hideColumn(this.header, property2header['durationUnknown']),
        hideColumn(this.header, property2header['orderUnknown']),
      ]);
    } else {
      result = result.concat([
        hideColumn(this.header, property2header['weeks']),
        hideColumn(this.header, property2header['orderUnknown']),
      ]);
    }

    return result;
  }

  async handleCreateGsheet() {

    this.processing = true;

    const {table, formats} = this;
    const {rawDataCollection: {references}} = this.props;
    const firstRef = references[0];
    const title = `${firstRef.author}. ` + (
      firstRef.medlineId ? `(PMID: ${firstRef.medlineId})`: ''
    );
    const {sheet} = this.state;

    const {rawDataCollection, onUpdate} = this.props;

    let spreadsheet_id = rawDataCollection.spreadsheet_id;
    let file_info = await createGsheet(
      spreadsheet_id, title, sheet, table, formats);

    if ((
      rawDataCollection.spreadsheet_id != file_info.spreadsheet_id) || (
        rawDataCollection.sheet_id != file_info.sheet_id)) {
      rawDataCollection.spreadsheet_id = file_info.spreadsheet_id;
      rawDataCollection.sheet_id = file_info.sheet_id;
      onUpdate(rawDataCollection);
    }

    this.processing = false;
  }

  handleDeleteGsheet(spreadsheet_id) {
    if (!spreadsheet_id) {
      return null;
    }

    return async () => {
      await deleteGsheet(spreadsheet_id);
    };
  }

  async handleUpdateColumn(column_name, value) {
    this.processing = true;
    const {sheet} = this.state;

    const property2header = this.property2header;

    await updateColumn(
      this.props.rawDataCollection.spreadsheet_id,
      sheet,
      getColumnIndexName(this.header, property2header[column_name]),
      value,
    );
    this.processing = false;
  }

  async handleShowHideColumns(columns) {
    const shownColumns = columns.show;
    const hiddenColumns = columns.hide;

    const property2header = this.property2header;

    let format = [];
    for (const column_name of shownColumns) {
      format.push(
        showColumn(this.header, property2header[column_name])
      );
    }
    for (const column_name of hiddenColumns) {
      format.push(
        hideColumn(this.header, property2header[column_name])
      );
    }

    const {sheet} = this.state;

    await updateSheet(this.props.rawDataCollection.spreadsheet_id, sheet, format);
  }

  handleCloseDialog() {
    this.setState({
      showValidateDialog: false,
      showSubmit: false,
    });
  }

  mapTableToObject(rows) {
    let headers = rows.shift();
    const header2Property = this.header2Property;
    headers = headers.map((header) => {
      return header2Property[header];
    });

    const object_list = [];
    for (const row of rows) {
      if (!lodash.some(row)) {
        continue;
      }
      object_list.push(zipObject(headers, row));
    }

    return object_list;
  }

  async handleContinue() {
    this.processing = true;
    const {sheet} = this.state;
    let {rawDataCollection} = this.props;

    let rows = await readGsheet(this.props.rawDataCollection.spreadsheet_id, sheet);

    rawDataCollection = updateData(
      rawDataCollection,
      this.mapTableToObject(rows)
    );

    rawDataCollection = await fetchDrugNames(rawDataCollection);

    rawDataCollection.validate();
    if (rawDataCollection.messages(
      'rawRxHistory', true, false, false).length > 0) {
      this.setState({
        showValidateDialog: true,
        showSubmit: true,
      });
    } else {
      this.setState({
        showValidateDialog: true,
        showSubmit: true,
      });
    }
    this.processing = false;
  }

  async handleSubmit() {
    const {rawDataCollection} = this.props;
    const {onUpdate, onSubmit} = this.props;
    await onUpdate(rawDataCollection);

    onSubmit();
  }

  handleDownload() {
    const {rawDataCollection} = this.props;
    downloadWorkbook(rawDataCollection);
  }

  get updateButtons() {
    const {rawDataCollection} = this.props;
    if (rawDataCollection.hasSimpleRawRxHistory) {
      return (
        <UpdatePanel
         rawDataCollection={rawDataCollection}
         onUpdateColumn={this.handleUpdateColumn.bind(this)}
         onShowHideColumns={this.handleShowHideColumns.bind(this)}
        />
      );
    } else {
      return null;
    }
  }

  render() {
    if (this.state.loadGSheet) {
      return <Loading />;
    }

    const {rawDataCollection} = this.props;
    const {showValidateDialog, showSubmit} = this.state;
    const {disableButtons} = this.state;
    return (
      <div>
        <div>
          {this.updateButtons}
        </div>
        <div>
          <ContinuePanel
           onDownload={this.handleDownload.bind(this)}
           onSubmit={this.handleContinue.bind(this)}
           disabled={disableButtons}
          />

          <DialogPrompt
           rawDataCollection={rawDataCollection}
           showDialog={showValidateDialog}
           showSubmit={showSubmit}
           onClose={
             this.handleCloseDialog.bind(this)}
           onSubmit={
             this.handleSubmit.bind(this)}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/rx-list/gtable/index.js